import * as actionType from "./action";

export function teamsReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_TEAMS_SUCCESS:
      return { ...state, response };
    case actionType.GET_TEAMS_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function teamReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_TEAM_SUCCESS:
      return { ...state, response };
    case actionType.GET_TEAM_ERROR:
      return { ...state, response };
    case actionType.ADD_TEAM_SUCCESS:
      return state;
    case actionType.ADD_TEAM_ERROR:
      return { ...state, response };
    case actionType.MODIFY_TEAM_SUCCESS:
      return state;
    case actionType.MODIFY_TEAM_ERROR:
      return { ...state, response };
    case actionType.DELETE_TEAM_SUCCESS:
      return state;
    case actionType.DELETE_TEAM_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function teamUsersReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_TEAM_USERS_SUCCESS:
      return { ...state, response };
    case actionType.GET_TEAM_USERS_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}

export function teamUserReducer(state = [], action: any) {
  const response = action.response;

  switch (action.type) {
    case actionType.GET_TEAM_USER_SUCCESS:
      return { ...state, response };
    case actionType.GET_TEAM_USER_ERROR:
      return { ...state, response };
    case actionType.ADD_TEAM_USER_SUCCESS:
      return state;
    case actionType.ADD_TEAM_USER_ERROR:
      return { ...state, response };
    case actionType.DELETE_TEAM_USER_SUCCESS:
      return state;
    case actionType.DELETE_TEAM_USER_ERROR:
      return { ...state, response };
    default:
      return state;
  }
}
